import { render, staticRenderFns } from "./Manufacturer.vue?vue&type=template&id=4de01e6e&scoped=true&"
import script from "./Manufacturer.vue?vue&type=script&lang=js&"
export * from "./Manufacturer.vue?vue&type=script&lang=js&"
import style0 from "./Manufacturer.vue?vue&type=style&index=0&id=4de01e6e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4de01e6e",
  null
  
)

export default component.exports